module.exports = __webpack_public_path__ + "images/kalaidoai917e465f71598eb5f12890c823331035.png";